import { mapActions, mapState } from "vuex";

import { DARK_MODE_ENUM } from "../../stores/constants";

export const darkModeMixin = {
  computed: {
    ...mapState({
      darkMode: (store) => {
        return store.DarkMode.darkMode === DARK_MODE_ENUM.TRUE;
      },
    }),
  },
  methods: {
    ...mapActions("DarkMode", ["switchDarkMode"]),
  },
};
